export const AdditionalErrorMessages = {
  NotFreeChip: 'FREE_CHIP_HAS_ENDED',
};

export const AdditionalNotificationByResponseCode = {
  NotFreeChip: 'error',
};

export const AdditionalResponseCode = {
  1007: 'NotFreeChip',
};
